import type { IBranding } from './Types/Branding.types';
import { WaterBranding } from './bff-water/Water';

type IBrandingRegistry = `bff-water`;

const BrandingRegistry: Record<IBrandingRegistry, IBranding> = {
  'bff-water': WaterBranding,
};

export { BrandingRegistry };
export { WaterBranding as DefaultBranding };
